import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import star from "../assets/image/Star.svg";
import "./style/LiveFeed.css";
import LiveBadge from "./LiveBadge";

export default function LiveFeed({ isTest = false }) {
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [jackpot, setJackpot] = useState(null);
  const feedRef = useRef(null);
  const streamUrl = "";

  // Тестовые данные
  const testData = {
    jackpot: {
      case: {
        id: 1,
        name: "Малый кейс",
        image: "/images/test-case.svg",
        value: 5000,
        color: "rgba(218,218,218,1)",
        win: 7500,
      },
      user: {
        username: "TestUser",
        avatar: "/images/fake-avatar.png",
      },
    },
    live: [
      {
        case: {
          id: 2,
          name: "Кейс 2",
          image: "/images/test-case.svg",
          value: 75,
          color: "rgba(255,200,0,1)",
          win: 200,
        },
        user: {
          username: "User1",
          avatar: "/images/fake-avatar.png",
        },
      },
      {
        case: {
          id: 3,
          name: "Кейс 3",
          image: "/images/test-case.svg",
          value: 100,
          color: "rgba(0,200,255,1)",
          win: 500,
        },
        user: {
          username: "User2",
          avatar: "/images/fake-avatar.png",
        },
      },
      {
        case: {
          id: 3,
          name: "Кейс 3",
          image: "/images/test-case.svg",
          value: 100,
          color: "rgba(0,200,255,1)",
          win: 500,
        },
        user: {
          username: "User2",
          avatar: "/images/fake-avatar.png",
        },
      },
      {
        case: {
          id: 3,
          name: "Кейс 3",
          image: "/images/test-case.svg",
          value: 100,
          color: "rgba(0,200,255,1)",
          win: 500,
        },
        user: {
          username: "User2",
          avatar: "/images/fake-avatar.png",
        },
      },
    ],
  };

  useEffect(() => {
    if (isTest) {
      setJackpot(testData.jackpot);
      setEntries(testData.live);
      return;
    }

    let ws = new WebSocket(streamUrl);

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.jackpot) setJackpot(data.jackpot);

      if (data.live) {
        setEntries((prev) => [data.live, ...prev].flat().slice(0, 50));
      }
    };

    return () => {
      ws.close();
    };
  }, [streamUrl, isTest]);

  useEffect(() => {
    if (feedRef.current) {
      feedRef.current.scrollTop = 0;
    }
  }, [entries]);

  return (
    <div className="live-feed-wrapper" style={{ display: "flex", gap: "12px" }}>
      {/* Jackpot */}
      <div className="live-jackpot-wrapper" onClick={() => navigate(`/case/${testData.jackpot.case.id}`)}>
        <img
          src={testData.jackpot.case.image}
          alt={testData.jackpot.case.name}
          className="live-feed-img"
        />
        <span className="jackpot-span">
          <img src={star} alt="star" style={{height: "20px", width: "20px", verticalAlign: "middle"}}/>
          {testData.jackpot.case.win}
        </span>
        <div className="jackpot-item-down">
          <svg xmlns="http://www.w3.org/2000/svg" width="112" height="21" viewBox="0 0 112 21" fill="none"> 
            <path d="M139 22C139 22.5523 138.552 23 138 23H-26C-26.5523 23 -27 22.5523 -27 22C-27 21.4477 -26.5523 21 -26 21H-6.47665C2.63174 21 10.584 14.8319 12.8496 6.00977C13.7581 2.47294 16.946 7.63522e-05 20.5977 0H88.4023C92.054 7.59712e-05 95.2419 2.47294 96.1504 6.00977C98.416 14.8319 106.368 21 115.477 21H138C138.552 21 139 21.4477 139 22Z" fill="#F9A301"/> 
          </svg> 
          <span>Last Jackpot</span>
        </div>
      </div>

      {/* Лента */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        flex: 1,
        minWidth: 0,
        position: "relative",
        whiteSpace: "nowrap"
      }}>
        <div className="live-feed" ref={feedRef}>
          {entries.map((entry, idx) => (
            <div
              key={idx}
              onClick={() => navigate(`/case/${entry.case.id}`)}
              className="live-feed-item"
              style={{
                "--glow-color": entry.case.color,
                "--glow-color-soft": `color-mix(in srgb, ${entry.case.color} 30%, transparent)`,
                flex: "none"  // чтобы элемент не сжимался
              }}
            >
              <img
                src={entry.case.image}
                alt={entry.case.name}
                className="live-feed-img"
              />
              <span className="live-span"><img src={star} alt="star"/> {entry.case.win}</span>
              <div className="live-item-down"></div>
            </div>
          ))}
        </div>
        <LiveBadge/>
      </div>
    </div>
  );
}
